import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface MasterModule {
  id: number;
  module_name: string;
  display_name: string;
  tool_tip: string | null;
  description: string | null;
  path: string | null;
  element_name: string | null;
  sequence: number | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface MasterModuleList {
  total: number;
  page: number;
  page_size: number;
  data: MasterModule[];
}

export interface MasterRole {
  id: number;
  name: string;
  display_name: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface MasterRoleList {
  total: number;
  page: number;
  page_size: number;
  data: MasterRole[];
}

export interface MasterAction {
  id: number;
  action_name: string;
  display_name: string;
  is_active: boolean;
}

export interface MasterActionList {
  total: number;
  page: number;
  page_size: number;
  data: MasterAction[];
}

const initialState: {
  modules: MasterModuleList;
  roles: MasterRoleList;
  actions: MasterActionList;
} = {
  modules: { total: 0, page: 1, page_size: 10, data: [] },
  roles: { total: 0, page: 1, page_size: 10, data: [] },
  actions: { total: 0, page: 1, page_size: 10, data: [] },
};

const masterManagementSlice = createSlice({
  name: "masterManagement",
  initialState,
  reducers: {
    setMasterRecordStatus(
      state,
      action: PayloadAction<{
        kind: "modules" | "roles" | "actions";
        id: number;
        is_active: boolean;
      }>
    ) {
      const record = state[action.payload.kind].data.find((row) => row.id === action.payload.id);
      if (record) record.is_active = action.payload.is_active;
    },
    setMasterModules(state, action: PayloadAction<MasterModuleList>) {
      state.modules = action.payload;
    },
    setMasterRoles(state, action: PayloadAction<MasterRoleList>) {
      state.roles = action.payload;
    },
    setMasterActions(state, action: PayloadAction<MasterActionList>) {
      state.actions = action.payload;
    },
  },
});

export const { setMasterModules, setMasterRoles, setMasterActions, setMasterRecordStatus } =
  masterManagementSlice.actions;
export default masterManagementSlice.reducer;
